import env from '@framework/env/env';
import { IDataroomTenantConfig } from '@/dataroom/domain/vo/DataroomTenantConfig';
import sharedConfig from '@dataroom/config';

export type TTenantConfigKey =
  'tenantDealvdr'
  | 'tenant17g5'
  | 'tenantInvestorSet'
  | 'tenantVeriSend'
  | 'tenantResearchRoom'
  | 'tenantLoansend';

const tenant: {
  [tenant in TTenantConfigKey]: IDataroomTenantConfig
} = {
  tenantDealvdr: {
    ...sharedConfig.dealvdr,
    productionHost: 'dealvdr.com',
    alertsEmail: env('CREDENTIALS__TENANT_DEALVDR__SUPPORT__ALERTS_EMAIL'),
    options: {
      ...sharedConfig.dealvdr.options,
      isManageAccessRequestsEnabled: false,
      isManageWhitelistEnabled: false,
      isDigestAlertsEnabled: true,
      isAnalyticsEnabled: true,
      isEmailUploadCustomFoldersEnabled: true,
      isTwoFactorOptionEnabled: true,
      isAudioUploadingEnabled: true,
      hasViewIntDialIns: true,
      isQnAEnabled: true,
      isDCEnabled: true,
      isRedactionEnabled: true,
      isConvertToPdfEnabled: true,
      tenantLabelPlural: 'Data Rooms',
      tenantSettingsPrefix: 'data-room-settings',
      isPermissionGroupsCreationEnabled: true,
      isEmailUploadingEnabled: true,
      isStagingEmailUploadingEnabled: true,
      isInviteStatusEnabled: false,
      isSinglePGAssignmentRestricted: false,
      isBulkDownloadOptionHidden: false,
      isAddTopAccountsEnabled: true,
    },
    sftp: {
      port: 2222,
    },
  },
  tenantLoansend: {
    ...sharedConfig.loansend,
    productionHost: 'loansend.com',
    alertsEmail: env('CREDENTIALS__TENANT_LOANSEND__SUPPORT__ALERTS_EMAIL'),

    options: {
      ...sharedConfig.loansend.options,
      isManageAccessRequestsEnabled: false,
      isManageWhitelistEnabled: false,
      isDigestAlertsEnabled: true,
      isAnalyticsEnabled: true,
      isEmailUploadCustomFoldersEnabled: true,
      isStagingEmailUploadingEnabled: false,
      isRedactionEnabled: true,
      isConvertToPdfEnabled: true,
      isTwoFactorOptionEnabled: true,
      isAudioUploadingEnabled: false,
      hasViewIntDialIns: true,
      isQnAEnabled: true,
      isDCEnabled: true,
      tenantLabelPlural: 'LoanSends',
      tenantSettingsPrefix: 'data-room-settings',
      isPermissionGroupsCreationEnabled: true,
      isEmailUploadingEnabled: true,
      isInviteStatusEnabled: false,
      isSinglePGAssignmentRestricted: false,
      isBulkDownloadOptionHidden: false,
      isAddTopAccountsEnabled: true,
    },
  },
  tenant17g5: {
    ...sharedConfig['17g5'],
    productionHost: '17g5.com',
    alertsEmail: env('CREDENTIALS__TENANT_17G5__SUPPORT__ALERTS_EMAIL'),
    options: {
      ...sharedConfig['17g5'].options,
      isManageAccessRequestsEnabled: false,
      isManageWhitelistEnabled: false,
      isDigestAlertsEnabled: false,
      isAnalyticsEnabled: false,
      isEmailUploadCustomFoldersEnabled: false,
      isTwoFactorOptionEnabled: true,
      isAudioUploadingEnabled: true,
      hasViewIntDialIns: true,
      isQnAEnabled: false,
      isDCEnabled: false,
      isRedactionEnabled: true,
      isConvertToPdfEnabled: true,
      tenantLabelPlural: 'Data Rooms',
      tenantSettingsPrefix: 'data-room-settings',
      isPermissionGroupsCreationEnabled: true,
      isEmailUploadingEnabled: true,
      isStagingEmailUploadingEnabled: false,
      isInviteStatusEnabled: false,
      isSinglePGAssignmentRestricted: false,
      isBulkDownloadOptionHidden: false,
      isAddTopAccountsEnabled: true,
    },
    sftp: {
      port: 2222,
    },
  },
  tenantInvestorSet: {
    ...sharedConfig.investorset,
    productionHost: 'investorset.com',
    alertsEmail: env('CREDENTIALS__TENANT_INVESTORSET__SUPPORT__ALERTS_EMAIL'),
    options: {
      ...sharedConfig.investorset.options,
      isManageAccessRequestsEnabled: true,
      isManageWhitelistEnabled: true,
      isDigestAlertsEnabled: true,
      isAnalyticsEnabled: true,
      isEmailUploadCustomFoldersEnabled: true,
      isTwoFactorOptionEnabled: true,
      isAudioUploadingEnabled: false,
      hasViewIntDialIns: false,
      isQnAEnabled: false,
      isDCEnabled: false,
      isRedactionEnabled: true,
      isConvertToPdfEnabled: true,
      tenantLabelPlural: 'InvestorSets',
      tenantSettingsPrefix: 'investorset-settings',
      isPermissionGroupsCreationEnabled: true,
      isEmailUploadingEnabled: true,
      isStagingEmailUploadingEnabled: false,
      isInviteStatusEnabled: false,
      isSinglePGAssignmentRestricted: false,
      isBulkDownloadOptionHidden: false,
      isAddTopAccountsEnabled: true,
    },
  },
  tenantVeriSend: {
    ...sharedConfig.verisend,
    productionHost: 'verisend.com',
    alertsEmail: env('CREDENTIALS__TENANT_VERISEND__SUPPORT__ALERTS_EMAIL'),
    options: {
      ...sharedConfig.verisend.options,
      isManageAccessRequestsEnabled: true,
      isManageWhitelistEnabled: true,
      isDigestAlertsEnabled: true,
      isAnalyticsEnabled: true,
      isEmailUploadCustomFoldersEnabled: true,
      isTwoFactorOptionEnabled: true,
      isAudioUploadingEnabled: false,
      hasViewIntDialIns: false,
      isQnAEnabled: false,
      isDCEnabled: false,
      isRedactionEnabled: true,
      isConvertToPdfEnabled: true,
      tenantLabelPlural: 'VeriSends',
      tenantSettingsPrefix: 'verisend-settings',
      isPermissionGroupsCreationEnabled: true,
      isEmailUploadingEnabled: false,
      isStagingEmailUploadingEnabled: false,
      isInviteStatusEnabled: false,
      isSinglePGAssignmentRestricted: false,
      isBulkDownloadOptionHidden: false,
      isAddTopAccountsEnabled: false,
    },
  },
  tenantResearchRoom: {
    ...sharedConfig.researchroom,
    productionHost: 'researchroom.com',
    alertsEmail: env('CREDENTIALS__TENANT_RESEARCHROOM__SUPPORT__ALERTS_EMAIL'),
    options: {
      ...sharedConfig.researchroom.options,
      isManageAccessRequestsEnabled: true,
      isManageWhitelistEnabled: true,
      isDigestAlertsEnabled: true,
      isAnalyticsEnabled: true,
      isEmailUploadCustomFoldersEnabled: true,
      isTwoFactorOptionEnabled: true,
      isAudioUploadingEnabled: false,
      hasViewIntDialIns: false,
      isQnAEnabled: false,
      isDCEnabled: false,
      isRedactionEnabled: false,
      isConvertToPdfEnabled: false,
      tenantLabelPlural: 'Research',
      tenantSettingsPrefix: 'researchroom-settings',
      isPermissionGroupsCreationEnabled: false,
      isEmailUploadingEnabled: false,
      isStagingEmailUploadingEnabled: false,
      isInviteStatusEnabled: true,
      isSinglePGAssignmentRestricted: true,
      isBulkDownloadOptionHidden: true,
      isAddTopAccountsEnabled: false,
    },
  },
};

const config: {
  tenant: {
    [tenant in TTenantConfigKey]: IDataroomTenantConfig
  },
} = {
  tenant,
};

export default config;
